export default "__VITE_ASSET__4a3a4aaf__"